export default __webpack_public_path__ + "dist/media/Twitter.aa568bfd.svg";